import React from "react";
import Sidebar from "../../components/moleculesv2/Sidebar/Sidebar";
import Text from "./../../components/Atomsv2/Text/Text";
export const NAV = [
    {
        group: "Atoms",
        items: [
            { id: "text",            label: "Text"           },
            { id: "button",          label: "Button"         },
            { id: "action-button",   label: "ActionButton"   },
            { id: "input",           label: "Input"          },
            { id: "textarea",        label: "Textarea"       },
            { id: "select",          label: "Select"         },
            { id: "multiselect",     label: "MultiSelect"    },
            { id: "calendar",        label: "Calendar"       },
            { id: "checkbox",        label: "Checkbox"       },
            { id: "avatar",          label: "Avatar"         },
            { id: "status",          label: "Status"         },
            { id: "toast",           label: "Toast"          },
            { id: "tooltip",         label: "Tooltip"        },
            { id: "animation-icons", label: "AnimationIcons" },
            { id: "modal",           label: "Modal"          },
            { id: "confirm",         label: "Confirm"        },
            { id: "empty-state",     label: "EmptyState"     },
        ],
    },
    {
        group: "Molecules",
        items: [
            { id: "collapse",      label: "Collapse"      },
            { id: "steps",         label: "Steps"         },
            { id: "options-group", label: "OptionsGroup"  },
            { id: "sidebar",       label: "Sidebar"       },
            { id: "header",        label: "Header"        },
            { id: "table",         label: "Table"         },
            { id: "side-drawer",   label: "SideDrawer"    },
            { id: "kanban-panel",       label: "KanbanPanel"      },
            { id: "info-tooltip",       label: "InfoTooltip"      },
            { id: "dropdown-button",    label: "DropdownButton"   },
            { id: "card-dashboard",     label: "CardDashboard"    },
        ],
    },
    {
        group: "Organisms",
        items: [
            { id: "side-panel",   label: "SidePanel"   },
            { id: "side-menu",    label: "SideMenu"    },
            { id: "auth-grid",    label: "AuthGrid"    },
            { id: "gantt-chart",  label: "GanttChart" },
        ],
    },
    {
        group: "Utils",
        items: [
            { id: "use-user-data",      label: "useUserData"      },
            { id: "rutas-protegidas",   label: "RutasProtegidas"  },
            { id: "api-interceptor",    label: "api (interceptor)" },
            { id: "sistema-ruteo",      label: "Sistema de Ruteo" },
        ],
    },
];

const BRAND = (
    <>
        <span className="icon" data-icon="widgets" />
        <Text weight={700} size="medium">UI Components</Text>
    </>
);

/**
 * DocsSidebar — Sidebar de documentación construido sobre el componente
 * genérico Sidebar. Pasa el NAV de componentes y el encabezado.
 *
 * Props:
 *   activeId   string     Id de la sección actualmente visible.
 *   onSelect   function   Recibe el id cuando el usuario hace clic en un ítem.
 *   className string     Clases CSS adicionales para el sidebar.
 */
const DocsSidebar = ({ activeId, onSelect , className }) => (
    <Sidebar
        nav={NAV}
        activeId={activeId}
        onSelect={onSelect}
        brand={BRAND}
        className={className}
    />
);

export default DocsSidebar;
